"use client"

import { useEffect, useRef } from "react"
import { ofetch } from "ofetch"

import { appStore$ } from "@/stores/app.v2.store"
import { DynamoRenewalServerResponseDataSchema, type IDynamoRenewalServerResponse } from "@/schemas/templates"

interface RefreshDynamoSessionClientProps {
  enabled: boolean
}

export function RefreshDynamoSessionClient({ enabled }: RefreshDynamoSessionClientProps) {
  const didRequestRefreshRef = useRef(false)

  useEffect(() => {
    if (!enabled || didRequestRefreshRef.current) {
      return
    }

    didRequestRefreshRef.current = true

    void ofetch<IDynamoRenewalServerResponse>("/api/dynamo/renew-token", {
      method: "POST",
      credentials: "include",
      retry: 0,
    })
      .then((response) => {
        const newTokenData = DynamoRenewalServerResponseDataSchema.safeParse(response?.dynamoDb)

        if (newTokenData.success) {
          appStore$.userData.dynamoDb.authorizationToken.set(newTokenData.data.authorizationToken)
        }
      })
      .catch(() => undefined)
  }, [enabled])

  return null
}
